import React, {useEffect, useRef, useState} from "react";
import {FormControl, InputLabel, Link, MenuItem, Select} from "@material-ui/core";
import {ServerApi} from "../ServerApi";
import {DictionaryGroup} from "../models/models";



export const ImportExportComponent: React.FC<any> = () => {
	const [dictionaryGroups, setDictionaryGroups] = useState<DictionaryGroup[]>([]);
	const [importDictionaryId, setImportDictionaryId] = useState<number>(-1);
	const [exportDictionaryId, setExportDictionaryId] = useState<number>(-1);
	const fileInputRef = useRef<HTMLInputElement>(null);


	useEffect(() => {
		ServerApi
			.getDictionaryGroups()
			.then(dgs => setDictionaryGroups(dgs));
	}, []);


	return (
		<>
			<div>
				<h2>가져오기</h2>

				<form action="/Api/Dictionary/Import" method="post" encType="multipart/form-data"
				      onSubmit={e => {
					      if (importDictionaryId < 1) {
						      e.preventDefault();
						      alert("가져오기 대상 사전을 선택해주세요.");
						      return;
					      }

					      if (!fileInputRef.current!.files || fileInputRef.current!.files.length < 1) {
						      e.preventDefault();
						      alert("가져오기할 파일을 선택해주세요.");
						      return;
					      }
				      }}>
					<FormControl variant="outlined" style={{width: "200px"}}>
						<InputLabel>사전</InputLabel>
						<Select value={importDictionaryId}
						        onChange={(e) => setImportDictionaryId(parseInt(e.target.value as string))}
						        variant="outlined"
						        name="dictionaryId"
						        label="사전">
							{dictionaryGroups
								.flatMap(dg => dg.dictionaries)
								.map(d =>
									<MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
								)
							}
						</Select>
					</FormControl>

					<br/>
					<br/>

					<input type="file" name="file" accept=".xlsx, .csv" ref={fileInputRef}/>

					<br/>
					<br/>

					<input type="submit" value="업로드"/>
				</form>
			</div>

			<hr style={{margin: "30px 0"}}/>

			<div>
				<h2>내보내기</h2>

				<FormControl variant="outlined" style={{width: "200px"}}>
					<InputLabel>사전</InputLabel>
					<Select value={exportDictionaryId}
					        onChange={(e) => setExportDictionaryId(parseInt(e.target.value as string))}
					        variant="outlined"
					        name="dictionaryId"
					        label="사전">
						{dictionaryGroups
							.flatMap(dg => dg.dictionaries)
							.map(d =>
								<MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
							)
						}
					</Select>
				</FormControl>

				<br/>
				<br/>

				<Link href={`/Api/Dictionary/Export?dictionaryId=${exportDictionaryId}`}
				      onClick={(e: React.MouseEvent<HTMLElement>) => {
					      if (exportDictionaryId < 1) {
						      e.preventDefault();
						      alert("내보내기할 사전을 선택해주세요.");
					      }
				      }}>
					다운로드
				</Link>
			</div>
		</>
	)
};